/* React */
import React from "react";

/* Ionic */
import { IonItem } from "@ionic/react";

/* Stylesheet */
import styles from "./ItemsContainer.module.scss";

/* Interfaces */
import { BasicProps } from "src/shared/interfaces/custom-cohorts/CustomCohorts";

interface ItemsContainerProps {
  items: BasicProps[];
  handleShowItems: (value: boolean) => void;
  disabled: boolean;
  onClick: (item: BasicProps) => void;
}

// extends ensures that the generic type T has a property called name
const ItemsContainer: React.FC<ItemsContainerProps> = ({
  items,
  handleShowItems,
  disabled,
  onClick,
}) => {
  return (
    <div className={styles.items_container}>
      {items?.map((item: BasicProps, index: number) => {
        return (
          <IonItem
            key={index}
            className={styles.item}
            lines="none"
            button
            onClick={() => {
              onClick(item);
              handleShowItems(false);
            }}
          >
            <div
              style={{
                color: disabled ? "var(--ion-color-text-disabled)" : undefined,
              }}
              className={styles.name}
            >
              {item.entity.name}
            </div>
          </IonItem>
        );
      })}
    </div>
  );
};

export default ItemsContainer;
